import PubSub from "../../utils/PubSub";
import { removeFromFavorites } from "../../pages/favorites/removeFromFavorites";

export default function setupOffcanvasFavoritesUI() {
  const favoriteToggle = document.querySelector("#favorite-toggle");
  const favoritesOffcanvas = document.querySelector(".favorites-offcanvas");
  const closeFavorites = document.querySelector(".close-favorites");
  const favoritesOffcanvasContent = document.querySelector(
    ".favorites-offcanvas-content"
  );
  const overlay = document.querySelector(".overlay");

  // Offcanvas control functions
  function openFavoritesOffcanvas() {
    favoritesOffcanvas.classList.remove("hide");
    favoritesOffcanvas.classList.add("show");
    overlay.classList.remove("hide");
    overlay.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  function closeFavoritesOffcanvas() {
    favoritesOffcanvas.classList.remove("show");
    favoritesOffcanvas.classList.add("hide");
    overlay.classList.remove("show");
    overlay.classList.add("hide");
    document.body.style.overflow = "";
  }

  // Event listeners for Offcanvas controls
  if (favoriteToggle)
    favoriteToggle.addEventListener("click", openFavoritesOffcanvas);
  if (closeFavorites)
    closeFavorites.addEventListener("click", closeFavoritesOffcanvas);
  if (overlay) overlay.addEventListener("click", closeFavoritesOffcanvas);

  // Favorites item interactions
  if (favoritesOffcanvasContent) {
    favoritesOffcanvasContent.addEventListener("click", (e) => {
      const favoriteItem = e.target.closest(".favorites-offcanvas-item");
      if (!favoriteItem) return;

      handleFavoriteItemInteraction(e, favoriteItem);
    });
  }

  // Subscribe to favorites update events
  setupFavoritesEventSubscriptions();
}

function handleFavoriteItemInteraction(e, favoriteItem) {
  const productId = favoriteItem.dataset.productId;

  if (e.target.classList.contains("remove-item")) {
    const formData = new FormData();
    formData.append("product_id", productId);
    removeFromFavorites(formData);
  }
}

function setupFavoritesEventSubscriptions() {
  // Handle add/remove favorites
  PubSub.subscribe("fetch:addToFavorites:success", ({ data }) => {
    updateFavoritesUI(data.favorites);
    updateFavoritesCount(data.favorites_count);
    openFavoritesOffcanvas();
  });

  PubSub.subscribe("fetch:removeFromFavorites:success", ({ data }) => {
    updateFavoritesUI(data.favorites);
    updateFavoritesCount(data.favorites_count);
  });

  // Handle error cases
  PubSub.subscribe("fetch:addToFavorites:error", ({ error }) => {
    console.error("Add to favorites error:", error);
  });

  PubSub.subscribe("fetch:removeFromFavorites:error", ({ error }) => {
    console.error("Remove from favorites error:", error);
  });
}

function updateFavoritesUI(items) {
  const container = document.querySelector(".favorites-offcanvas-items");
  if (!container) {
    const favoritesContent = document.querySelector(
      ".favorites-offcanvas-content"
    );
    if (favoritesContent && items && items.length > 0) {
      // Ensure we're using the correct translation from favoritesVars
      const viewAllText =
        favoritesVars.texts.viewAllFavorites || "View All Favorites";
      favoritesContent.innerHTML = `
        <div class="favorites-offcanvas-items"></div>
        <div class="favorites-offcanvas-footer">
          <a href="/favorites" class="view-all-favorites">
            ${viewAllText}
          </a>
        </div>
      `;
      updateFavoritesUI(items);
      return;
    }
    return;
  }

  if (!items || !items.length) {
    const favoritesContent = container.closest(".favorites-offcanvas-content");
    if (favoritesContent) {
      const emptyText =
        favoritesVars.texts.favoritesEmpty || "No favorites yet";
      const shopNowText = favoritesVars.texts.shopNow || "Shop Now";

      favoritesContent.innerHTML = `
        <div class="empty-favorites-message">
          <p>${emptyText}</p>
          <a href="${cartVars.shopUrl}" class="button">${shopNowText}</a>
        </div>
      `;
    }
    return;
  }

  container.innerHTML = items
    .map(
      (item) => `
    <div class="favorites-offcanvas-item" data-product-id="${item.id}">
      <a href="${item.url}">
        <div class="item-image">
          <img src="${item.image}" alt="${item.name}">
        </div>
      </a>
      <div class="item-details">
        <h3>${item.name}</h3>
        <div class="item-price">${item.price}</div>
        ${
          !item.is_in_stock
            ? `<span class="out-of-stock">${favoritesVars.texts.outOfStock}</span>`
            : `<a href="${item.url}" class="go-to-product-button">${favoritesVars.texts.goToProduct}</a>`
        }
      </div>
      <button class="remove-item" title="${
        favoritesVars.texts.removeFromFavorites
      }">×</button>
    </div>
  `
    )
    .join("");

  setupFavoriteItemEventListeners();
}

function setupFavoriteItemEventListeners() {
  const favoriteItems = document.querySelectorAll(".favorites-offcanvas-item");

  favoriteItems.forEach((item) => {
    const removeButton = item.querySelector(".remove-item");

    if (removeButton) {
      removeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData();
        formData.append("product_id", item.dataset.productId);
        removeFromFavorites(formData);
      });
    }
  });
}

export function openFavoritesOffcanvas() {
  const favoritesOffcanvas = document.querySelector(".favorites-offcanvas");
  const overlay = document.querySelector(".overlay");

  if (favoritesOffcanvas && overlay) {
    favoritesOffcanvas.classList.remove("hide");
    favoritesOffcanvas.classList.add("show");
    overlay.classList.remove("hide");
    overlay.classList.add("show");
    document.body.style.overflow = "hidden";
  }
}

function updateFavoritesCount(count = 0) {
  document.querySelectorAll(".favorites-count").forEach((el) => {
    el.textContent = count;
  });
}
